export default __webpack_public_path__ + "static/media/uulzalt1.74ba6a27.png";